module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-38.24301ac3.png";